import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { williamsportConfig } from "./data";

export default function WilliamsportPage() {
  return <CityPageTemplate config={williamsportConfig} />;
}